module.exports = __webpack_public_path__ + "img/compliance-4.0ed89abf.png";